import React from 'react';

function Dashboard() {
    return (
        <h1>About us</h1>
    );
}

export default Dashboard;
